import React, { memo, ReactNode } from 'react';

import { areEqual } from 'Utils/equalityChecks';

import classes from './ghlLayout.module.css';

interface Props {
  children: ReactNode;
}

// Minimal layout for GHL embedded views - no sidebar, no navigation
const GHLLayout = ({ children }: Props) => (
  <div className={`d-flex flex-column w-100 ${classes.ghlBase}`}>
    <div className={classes.ghlContent}>{children}</div>
  </div>
);

const GHLLayoutMemo = memo(GHLLayout, areEqual);

export { GHLLayoutMemo as GHLLayout };
